/* Pretty Polish reviews: public read-only Widget API; no Judge.me widget renderer. */
(() => {
  const init = scope => scope.querySelectorAll('[data-pp-reviews]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const button = root.querySelector('[data-review-more]');
    const labels = JSON.parse(root.querySelector('[data-review-labels]').textContent);
    const grid = root.querySelector('.ppr__cards');
    const progress = root.querySelector('[data-review-progress]');
    const error = root.querySelector('[data-review-error]');
    let page = 0, busy = false;
    const text = (tag, className, value) => {
      const el = document.createElement(tag); el.className = className; el.textContent = value ?? ''; return el;
    };
    const plain = html => new DOMParser().parseFromString(String(html || ''), 'text/html').body.textContent;
    const safeImage = value => { try { const url = new URL(value); return url.protocol === 'https:' ? url.href : null; } catch { return null; } };
    const card = review => {
      const el = text('article', 'ppr__card', ''); el.dataset.reviewId = review.uuid; el.tabIndex = -1;
      const head = text('div', 'ppr__cardhead', '');
      const rating = Math.max(0, Math.min(5, Number(review.rating) || 0));
      const stars = text('span', 'ppr__stars', '★'.repeat(rating) + '☆'.repeat(5 - rating));
      stars.setAttribute('aria-label', labels.rating.replace('__RATING__', rating)); head.append(stars);
      const date = new Date(review.created_at);
      if (!isNaN(date)) { const time = text('time', '', new Intl.DateTimeFormat(document.documentElement.lang || 'nl').format(date)); time.dateTime = date.toISOString().slice(0,10); head.append(time); }
      el.append(head);
      if (review.title) el.append(text('h3', '', review.title));
      el.append(text('p', 'ppr__body', review.body || plain(review.body_html)));
      if (Array.isArray(review.pictures_urls) && review.pictures_urls.length) {
        const photos = text('div', 'ppr__photos', '');
        review.pictures_urls.forEach(p => {
          const href = safeImage(p.original); if (!href) return;
          const link = document.createElement('a'); link.href = href; link.target = '_blank'; link.rel = 'noopener'; link.setAttribute('aria-label', labels.photo);
          const image = document.createElement('img'); image.src = safeImage(p.small) || href; image.alt = labels.photo; image.width = 96; image.height = 96; image.loading = 'lazy'; link.append(image); photos.append(link);
        }); el.append(photos);
      }
      const author = text('p', 'ppr__author', ''); author.append(text('strong', '', review.reviewer_name));
      if (review.verified_buyer === true) author.append(text('span', '', labels.verified)); el.append(author);
      if (review.is_for_product_from_group) { const product = text('p', 'ppr__product', labels.product+' '); product.append(text('strong', '', review.product_title)); el.append(product); }
      if (review.reply_content) { const reply = text('details', 'ppr__reply', ''); reply.append(text('summary', '', labels.reply), text('p', '', plain(review.reply_content))); el.append(reply); }
      return el;
    };
    // Older Judge.me installations expose cached public reviews as HTML instead of JSON.
    // Read the inert template and create the same Pretty Polish cards with textContent.
    const legacy = root.querySelector('[data-review-legacy]');
    if (legacy && grid) {
      const source = legacy.content;
      const reviews = [...source.querySelectorAll('.jdgm-rev')].map(el => ({
        uuid: el.dataset.reviewId,
        rating: Number(el.querySelector('.jdgm-rev__rating')?.dataset.score || 0),
        created_at: el.querySelector('time')?.getAttribute('datetime'),
        title: el.querySelector('.jdgm-rev__title')?.textContent || '',
        body: el.querySelector('.jdgm-rev__body')?.textContent || '',
        reviewer_name: el.querySelector('.jdgm-rev__author')?.textContent || '',
        verified_buyer: el.dataset.verifiedBuyer === 'true',
        reply_content: el.querySelector('.jdgm-rev__reply')?.textContent?.trim() || '',
        product_title: el.dataset.productTitle || '',
        is_for_product_from_group: !!el.dataset.productUrl && !el.dataset.productUrl.endsWith('/products/' + root.dataset.product),
        pictures_urls: [...el.querySelectorAll('.jdgm-rev__pics a')].map(a => ({original:a.href,small:a.querySelector('img')?.getAttribute('src')}))
      })).filter(review => review.uuid);
      if (reviews.length) {
        grid.replaceChildren(...reviews.map(card));
        const bars = [...source.querySelectorAll('.jdgm-histogram__row[data-frequency]')];
        if (bars.length && !root.querySelector('.ppr__histogram')) {
          const histogram = text('ul', 'ppr__histogram', '');
          bars.forEach(bar => {
            const rating = Number(bar.dataset.rating), count = Number(bar.dataset.frequency);
            if (!(rating >= 1 && rating <= 5) || !Number.isFinite(count)) return;
            const row = document.createElement('li');
            const meter = document.createElement('meter'); meter.min = 0; meter.max = Number(root.dataset.reviewCount); meter.value = count;
            meter.setAttribute('aria-label', rating + ' ★: ' + count);
            row.append(text('span', '', rating + ' ★'), meter, text('span', '', count)); histogram.append(row);
          });
          root.querySelector('.ppr__summary')?.append(histogram);
        }
        if (progress) progress.textContent = labels.progress.replace('__SHOWN__', reviews.length).replace('__COUNT__', root.dataset.reviewCount);
        if (button) button.hidden = reviews.length >= Number(root.dataset.reviewCount);
      }
    }
    if (!button) return;
    const fetchPage = async number => {
      const url = new URL('https://judge.me/api/v1/widgets/product_review');
      url.search = new URLSearchParams({shop_domain:root.dataset.shop, api_token:root.dataset.token, handle:root.dataset.product, page:String(number), per_page:'25', json_request:'true'});
      const controller = new AbortController(); const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, {signal:controller.signal, credentials:'omit'});
        if (!response.ok) throw new Error('Review HTTP '+response.status);
        const payload = await response.json();
        let data = payload.widget || payload;
        if (typeof data === 'string') data = JSON.parse(data);
        data.pagination ||= {current_page:data.current_page,total_pages:data.total_pages,per_page:data.per_page};
        if (!Array.isArray(data.reviews) || !data.pagination || Number(data.pagination.current_page) !== number) throw new Error('Unexpected review data');
        return data;
      } finally { clearTimeout(timer); }
    };
    button.addEventListener('click', async () => {
      if (busy) return; busy = true; button.disabled = true; button.textContent = labels.loading; error.hidden = true; grid.setAttribute('aria-busy','true');
      try {
        // Refresh page one before paging, so stale metafield caches cannot skip reviews.
        const refresh = page === 0;
        const first = await fetchPage(page + 1);
        const data = Number(first.pagination.current_page) < Number(first.pagination.total_pages) ? await fetchPage(page + 2) : first;
        const batch = data === first ? first.reviews : [...first.reviews, ...data.reviews];
        const fragment = document.createDocumentFragment();
        const ids = new Set(refresh ? [] : Array.from(grid.children, el => el.dataset.reviewId));
        let firstNew;
        for (const review of batch) {
          if (!review.uuid || ids.has(review.uuid)) continue;
          ids.add(review.uuid); const node = card(review); fragment.append(node);
          if (!firstNew) firstNew = node;
        }
        if (refresh) grid.replaceChildren(fragment); else grid.append(fragment);
        page = Number(data.pagination.current_page);
        const total = page >= Number(data.pagination.total_pages) ? grid.children.length : (data.number_of_reviews || root.dataset.reviewCount);
        progress.textContent = labels.progress.replace('__SHOWN__', grid.children.length).replace('__COUNT__', total);
        button.hidden = page >= Number(data.pagination.total_pages);
        firstNew?.focus({preventScroll:true});
      } catch { error.textContent = labels.error; error.hidden = false; }
      finally { busy = false; button.disabled = false; button.textContent = labels.more; grid.removeAttribute('aria-busy'); }
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
